import { QueryKeys } from '../../../enums/queryKeys'
import { BankLinesQueryParams } from '../query-api'

export const getBankLinesQueryKey = (
  queryProps: Partial<BankLinesQueryParams>,
): [QueryKeys, Partial<BankLinesQueryParams>] => [QueryKeys.BankLines, queryProps]
